import Reveal from './Reveal'

const STEPS = [
  {
    n: '01',
    title: 'Discovery call',
    meta: '15 minutes',
    desc: 'We talk through what you do, where you work, what customers ask, and what the site needs to achieve.',
  },
  {
    n: '02',
    title: 'Website plan',
    meta: '1 to 2 days',
    desc: 'I map the pages, services, calls to action, and local SEO basics before any design starts.',
  },
  {
    n: '03',
    title: 'Build and review',
    meta: '2 to 4 days',
    desc: 'I build the site, write the key page copy, set up your forms, and send it through for a proper review.',
  },
  {
    n: '04',
    title: 'Launch and handover',
    meta: '1 day',
    desc: 'We go live, check everything works, and I walk you through exactly what has been set up.',
  },
]

const Process = () => {
  return (
    <section id="process" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-container px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl">
            A simple process that does not drag on.
          </h2>
          <p className="mt-6 text-lg text-ink-soft">
            Most projects move fast because the scope is clear from day one. Fixed price, a page plan,
            review rounds, and a clean handover.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-xl2 border border-[var(--line)] bg-[var(--line)] sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.07}>
              <div className="group flex h-full flex-col bg-cream p-7 transition-colors duration-300 hover:bg-paper lg:p-8">
                <div className="flex items-baseline justify-between">
                  <span className="font-display text-5xl font-extrabold text-ink/15 transition-colors duration-300 group-hover:text-gold lg:text-6xl">
                    {s.n}
                  </span>
                  <span className="rounded-full bg-gold/10 px-3 py-1 text-[0.72rem] font-semibold uppercase tracking-wider text-gold">
                    {s.meta}
                  </span>
                </div>
                <h3 className="font-display mt-6 text-xl font-bold text-ink">{s.title}</h3>
                <p className="mt-3 text-[0.92rem] leading-relaxed text-ink-soft">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-8">
          <div className="inline-flex items-center gap-4 rounded-full border border-[var(--line)] bg-paper px-6 py-3 shadow-soft">
            <span className="font-display text-2xl font-extrabold text-ink">5 to 7 days</span>
            <span className="h-5 w-px bg-[var(--line-strong)]" />
            <span className="text-sm text-ink-soft">total time to launch a Starter site</span>
          </div>
        </Reveal>
      </div>
    </section>
  )
}

export default Process
